var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRegion1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3272 5.58317V3.24984H9.66053V5.58317H14.3272ZM2.66053 7.9165V20.7498H21.3272V7.9165H2.66053ZM23.6605 5.58317V23.0832H0.338867V5.58317H7.3272V3.24984C7.3272 1.9665 8.3772 0.916504 9.66053 0.916504H14.3272C15.6105 0.916504 16.6605 1.9665 16.6605 3.24984V5.58317H23.6605Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegion1);
export default __webpack_public_path__ + "static/media/icon_region1.b3b555a0a40404f4cd99ba7d3ecc4533.svg";
export { ForwardRef as ReactComponent };